import styled from 'styled-components';
import { mobileThreshold } from '../../Constants/layoutValues';

export const AboutSectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	font-size: 0.95em;
	margin-bottom: -1rem;
	background-color: #001c4c;
	color: #fff;
	min-height: 100vh;
	min-width: 270px;
	max-width: 300px;
	print-color-adjust: exact;
	padding-left: 1rem;
	padding-right: 1rem;
	@media print {
		z-index: 100;
		min-height: 100%;
		background-color: #001c4c;
		padding-left: 0.5rem;
		padding-right: 0.25rem;
		min-width: 115px;
		max-width: 115px;
		padding-bottom: 0.5em;
		font-size: 0.5rem;
		padding-top: 0;
	}
	@media (max-width: ${mobileThreshold}px) {
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		flex-direction: column;
		max-width: 100%;
	}
`;

export const ContactContentWrapper = styled('div')`
	//padding-left: 1rem;
	@media print {
		padding-left: 0;
	}
`;
